<template>
    <img v-if="media"
         :alt="media.name"
         loading="lazy"
         :src="media.original"
         :srcset="srcset"
         :title="media.name"
         class="rounded-lg"
    >
</template>

<script lang="ts">
import type {PropType} from 'vue'

const RESOLUTIONS = {
  lg: 1920,
  sm: 800,
  md: 768,
  tb: 150,
} as { [key: string]: number }

export default {
  name: 'ResponsiveImage',
  props: {
    media: {
      type: Object as PropType<Media | null>,
      default: null
    }
  },
  computed: {
    srcset() {
      if (!this.media) return undefined

      const resolutions = Object.keys(RESOLUTIONS)
      return Object.entries(this.media.conversions)
          .filter(([key]) => resolutions.includes(key))
          .sort((srcA, srcB) => RESOLUTIONS[srcA[0]] - RESOLUTIONS[srcB[0]])
          .map(src => `${src[1]} ${RESOLUTIONS[src[0]]}w`)
          .join(', ')
    },
    style() {
      if (!this.media) return null

      return this.media.conversions.pl ? `background-image: url("${this.media.conversions.pl}")` : null
    }
  }
}
</script>
